import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

// Modules
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { MaterialModule } from '../material/material.module';
import { TranslateModule } from '@ngx-translate/core';
import { IonicModule } from '@ionic/angular';
// import { CalendarModule } from 'ion2-calendar';
import { ColorPickerModule } from 'ngx-color-picker';

// Components
import { MenuComponent } from './components/menu/menu.component';
import { MenuItemDividerComponent } from './components/menu/item-divider/item-divider.component';
import { MenuItemOptionComponent } from './components/menu/item-option/item-option.component';
import { MenuItemTitleComponent } from './components/menu/item-title/item-title.component';
import { ProfileComponent } from './components/profile/profile.component';
import { FilterMenuComponent } from './components/filter-module/filter-menu/filter-menu.component';
import { FilterItemInputComponent } from './components/filter-module/filter-input/filter-input.component';
import { FilterItemCalendarComponent } from './components/filter-module/filter-calendar/filter-calendar.component';
import { FilterItemBooleanComponent } from './components/filter-module/filter-boolean/filter-boolean.component';
import { FilterItemNumberRangeComponent } from './components/filter-module/filter-number-range/filter-number-range.component';

//Services
import { ToastService } from './services/toast.service';
import { LoaderService } from './services/loader.service';
import { LayoutComponent } from './components/layout/layout.component';
import { FilterDataService } from './components/filter-module/filter-data.service';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DeviceAttributesComponent } from './components/device-attributes/device-attributes.component';
import { SensorIconComponent } from './components/sensor-icon/sensor-icon.component';
import { SensorLimitComponent } from './components/sensor-limit/sensor-limit.component';
import { SensorRangeComponent } from './components/sensor-limit/sensor-range.component';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { PublishPreviewModalComponent } from './components/publish-preview-modal/publish-preview-modal.component';
import { ConfirmSaveModalComponent } from './components/confirm-save-modal/confirm-save-modal.component';
import { BillingSummaryComponent } from './components/billing-summary/billing-summary.component';
import { NgChartsModule } from 'ng2-charts';
import { HighchartsChartModule } from 'highcharts-angular';
import { UserAccessLogComponent } from '../views/main/superadmin/users/containers/user-access-log/user-access-log.component';
import { StackSettingsComponent } from './components/stack-settings/stack-settings.component';
import { InfoStackComponent } from './components/info-stack/info-stack.component';
import { GraphBatteryCoverageComponent } from './components/graph-battery-coverage/graph-battery-coverage.component';
import { DevicesService } from '../views/main/superadmin/services/devices.service';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { GridsterModule } from 'angular-gridster2';
import { AreaPropertiesFormComponent } from '../views/main/superadmin/areas/components/area-properties-form/area-properties-form.component';
import { AreaStructureViewComponent } from '../views/main/superadmin/areas/components/area-structure-view/area-structure-view.component';
import { PulseWaterRegisterComponent } from './components/device-attributes/sensor-advanced-properties/pulse-water-register/pulse-water-register.component';
import { AreaBreadcrumbComponent } from './components/area-breadcrumb/area-breadcrumb.component';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { WidgetRendererComponent } from './components/dashboard-widgets/widget-renderer/widget-renderer.component';
import { WidgetNumberComponent } from './components/dashboard-widgets/widget-number/widget-number.component';
import { WidgetLineChartComponent } from './components/dashboard-widgets/widget-line-chart/widget-line-chart.component';
import { WidgetBarChartComponent } from './components/dashboard-widgets/widget-bar-chart/widget-bar-chart.component';
import { WidgetDeviceListComponent } from './components/dashboard-widgets/widget-device-list/widget-device-list.component';
import { WidgetMapComponent } from './components/dashboard-widgets/widget-map/widget-map.component';
import { WidgetCardHeaderComponent } from './components/dashboard-widgets/widget-card-header/widget-card-header.component';
import { WidgetPreviewComponent } from './components/dashboard-widgets/widget-preview/widget-preview.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { LevelEmbalseComponent } from './components/device-attributes/sensor-advanced-properties/level-embalse/level-embalse.component';
import { GeoLocationPickerComponent } from './components/geo-location-picker/geo-location-picker.component';

@NgModule({
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    IonicModule,
    RouterModule,
    TranslateModule,
    MaterialModule,
    // CalendarModule,
    MatProgressBarModule,
    ColorPickerModule,
    NgChartsModule,
    HighchartsChartModule,
    MatSlideToggleModule,
    DragDropModule,
    GridsterModule,
  ],
  declarations: [
    MenuComponent,
    MenuItemDividerComponent,
    MenuItemOptionComponent,
    MenuItemTitleComponent,
    ProfileComponent,
    LayoutComponent,
    FilterMenuComponent,
    FilterItemInputComponent,
    FilterItemCalendarComponent,
    FilterItemBooleanComponent,
    FilterItemNumberRangeComponent,
    DeviceAttributesComponent,
    SensorLimitComponent,
    SensorRangeComponent,
    SensorIconComponent,
    DeleteModalComponent,
    PublishPreviewModalComponent,
    ConfirmSaveModalComponent,
    BillingSummaryComponent,
    UserAccessLogComponent,
    StackSettingsComponent,
    InfoStackComponent,
    GraphBatteryCoverageComponent,
    AreaPropertiesFormComponent,
    AreaStructureViewComponent,
    PulseWaterRegisterComponent,
    BreadcrumbComponent,
    AreaBreadcrumbComponent,
    WidgetRendererComponent,
    WidgetNumberComponent,
    WidgetLineChartComponent,
    WidgetBarChartComponent,
    WidgetDeviceListComponent,
    WidgetMapComponent,
    WidgetCardHeaderComponent,
    WidgetPreviewComponent,
    DashboardComponent,
    LevelEmbalseComponent,
    GeoLocationPickerComponent,

  ],
  exports: [
    CommonModule,
    RouterModule,
    FormsModule,
    IonicModule,
    MaterialModule,
    ReactiveFormsModule,
    TranslateModule,
    MenuComponent,
    ProfileComponent,
    LayoutComponent,
    FilterMenuComponent,
    DatePipe,
    MatProgressBarModule,
    SensorIconComponent,
    BillingSummaryComponent,
    NgChartsModule,
    HighchartsChartModule,
    UserAccessLogComponent,
    StackSettingsComponent,
    InfoStackComponent,
    GraphBatteryCoverageComponent,
    MatSlideToggleModule,
    DragDropModule,
    GridsterModule,
    AreaPropertiesFormComponent,
    AreaStructureViewComponent,
    PulseWaterRegisterComponent,
    BreadcrumbComponent,
    AreaBreadcrumbComponent,
    WidgetRendererComponent,
    WidgetNumberComponent,
    WidgetLineChartComponent,
    WidgetBarChartComponent,
    WidgetDeviceListComponent,
    WidgetMapComponent,
    WidgetCardHeaderComponent,
    WidgetPreviewComponent,
    DashboardComponent,
    LevelEmbalseComponent,
    GeoLocationPickerComponent,
  ],

  providers: [
    LoaderService,
    ToastService,
    FilterDataService,
    DevicesService
  ]
})
export class SharedModule { }
